import './angular'
import './qrcode'
import './angular-qrcode'
angular.module('app', ['monospaced.qrcode'])
angular.element(document).ready(function(){
  angular.bootstrap(document, ['app']);
});
